import { render, staticRenderFns } from "./AccountAudioFileTypes.vue?vue&type=template&id=fbabcdf0"
import script from "./AccountAudioFileTypes.vue?vue&type=script&lang=js"
export * from "./AccountAudioFileTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports